import { render, staticRenderFns } from "./FreightOrderHistoryModal.vue?vue&type=template&id=74a41f38&scoped=true&"
import script from "./FreightOrderHistoryModal.vue?vue&type=script&lang=js&"
export * from "./FreightOrderHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a41f38",
  null
  
)

export default component.exports